import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-63ae304e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "user-contest"
};
var _hoisted_2 = {
  class: "list-container"
};
import ContestList from '@/views/contest/2025/common/components/ContestList/index.vue';
import ContestTabs from '@/views/contest/2025/common/components/ContestTabs/index.vue';
import { AiicUserExamService } from '@/services/contest/2026/aiic.service';
import { useService } from '@kaokei/use-vue-service';
import { computed, onUnmounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { StateMap } from '@/views/contest/2025/common/js/utils';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var aiicUserExamService = useService(AiicUserExamService);
    var route = useRoute();
    var contestData = computed(function () {
      return aiicUserExamService.userExamList || [];
    });
    var pageStatus = computed(function () {
      var state = route.query.state;
      if (state && state in StateMap) {
        return StateMap[state].status;
      }
      return 1;
    });
    watch(pageStatus, function (newStatus) {
      aiicUserExamService.setAttrs({
        status: newStatus,
        activityTag: 'aiic-2026'
      });
      aiicUserExamService.search();
    }, {
      immediate: true
    });
    onUnmounted(function () {
      aiicUserExamService === null || aiicUserExamService === void 0 ? void 0 : aiicUserExamService.clearTimer();
    });
    return function (_ctx, _cache) {
      var _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_spin, {
        size: "large",
        tip: "正在加载数据中...",
        spinning: _ctx.iccUserExamService.loading,
        delay: 120
      }, {
        default: _withCtx(function () {
          return [_createVNode(ContestTabs), _createElementVNode("div", _hoisted_2, [_createVNode(ContestList, {
            list: _unref(contestData),
            pagination: false
          }, null, 8, ["list"])])];
        }),
        _: 1
      }, 8, ["spinning"])]);
    };
  }
});